/**
 * @author Filipe DA COSTA
 */
class URL {

    constructor() {

        this.protocol = location.protocol;
        this.host = location.host;
        this.pathname = location.pathname;
        this.search = location.search;
        
        this.params = this.parseArguments();
                
    }

    /**
     * Source : https://stackoverflow.com/questions/2090551/parse-query-string-in-javascript#13896633
     * @returns {{}}
     */
    parseArguments() {
        if (typeof this.search != "string" || this.search.length == 0) return {};
        let s = this.search.substring(1).split("&");
        let s_length = s.length;
        let bit, query = {}, first, second;
        for (let i = 0; i < s_length; i++) {
            bit = s[i].split("=");
            first = decodeURIComponent(bit[0]);
            if (first.length == 0) continue;
            second = decodeURIComponent(bit[1]);
            if (typeof query[first] == "undefined") query[first] = second;
            else if (query[first] instanceof Array) query[first].push(second);
            else query[first] = [query[first], second];
        }
        return query;
    }

    getCleanURL() {
        return this.protocol + '//' + this.host + this.pathname;
    }

    hasIndex() {
        return this.pathname.indexOf('index.php') > -1;
    }
    
    hasPageId(){
        return this.params['id'] !== undefined;
    }
    
    isRealURL(){
        return !this.hasIndex() || !this.hasPageId();
    }
    
    getUrlWithTarget(aTarget){
        return (!this.isRealURL() ? '/' : this.getCleanURL() ) + aTarget;
    }
    
    getUrlForAPI(){
        return this.getUrlWithTarget('api.json');
    }

}

export default new URL();
